





























import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";

export default createComponent({
  setup(props: {}, context: SetupContext) {
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }

    const confirmDialogFlag = computed(() => displayuiStore.confirmDialogFlag);

    const openConfirmDialog = displayuiStore.openConfirmDialog;
    const closeConfirmDialog = displayuiStore.closeConfirmDialog;

    return {
      confirmDialogFlag,
      openConfirmDialog,
      closeConfirmDialog
    };
  }
});
